import { Component } from '@angular/core';

@Component({
  selector: 'app-transaction-list-shimmer',
  standalone: true,
  imports: [],
  templateUrl: './transaction-list-shimmer.component.html',
  styleUrl: './transaction-list-shimmer.component.scss'
})
export class TransactionListShimmerComponent {
  numbers = Array(4).fill(1);


}
